import moment from 'moment';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { CheckCircleOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import React, { useEffect, useState } from 'react';
import { Empty, Input, message, Modal } from 'antd';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import { Button } from '../../../components/buttons/buttons';
import { updateCase, FetchCaseDetails } from '../../../Api/Services/CaseApiServices'
import { validateDescriptionField } from '../../../components/utilities/utilities';

const UserTable = ({ displayData, refreshTrigger, tabKey }) => {
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const [notes, setNotes] = useState();
    const [allNotes, setAllNotes] = useState([]);
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    function getCurrentDateTimeFromZoneString(tzStr) {
        if (!tzStr) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const timezone = extractTimezoneName(tzStr)
        if (!moment.tz.zone(timezone)) {
            console.warn("Invalid timezone:", timezone);
            return "";
        }
        return moment.tz(timezone).format("YYYY-MM-DD HH:mm");
    }
    const setProjectNotesData = (value) => {
        if (value.internalComments && value.internalComments !== '[]' && value.internalComments !== '') {
            setAllNotes(value.internalComments);
        } else {
            setAllNotes([]);
        }
    };
    async function getProjectNotesById(id) {
        try {
            const response = await FetchCaseDetails(id);
            setProjectNotesData(response.data);
        } catch (error) {
            message.error(error);
        }
    }
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const handleAddNote = async () => {
        let hideMessage;
        const data = {
            id: profile.userId,
            name: `${profile.firstName} ${profile.lastName}`,
            time: getCurrentDateTimeFromZoneString(companyProfile?.timeZone),
            content: notes,
        };
        setAllNotes((prevNotes) => [data, ...prevNotes]);
        setNotes('');
        const NewNotes = [data, ...allNotes]
        const formData = {
            internalComments: NewNotes,
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await updateCase(formData, displayData?.caseId)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                    hideMessage();
                }
                else {
                    hideMessage();
                    const isAutomation = response.data[0].message === AutomationMessage;
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    } else {
                        message.success(
                            <span>
                                Case <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                            </span>
                        );
                    }
                    getProjectNotesById(displayData?.caseId)
                }
            }
            setNotes('');
        } catch (error) {
            hideMessage();
            message.error(error)
        }
    };
    const NoteDelete = async (id) => {
        let hideMessage;
        const updatedFormData = [...allNotes];
        updatedFormData.splice(id, 1);
        setAllNotes(updatedFormData);
        const formData = {
            internalComments: updatedFormData,
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await updateCase(formData, displayData?.caseId)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                    hideMessage();
                }
                else {
                    hideMessage();
                    const isAutomation = response.data[0].message === AutomationMessage;
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    } else {
                        message.success(
                            <span>
                                Case <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                            </span>
                        );
                    }
                    getProjectNotesById(displayData?.caseId)
                }
            }
            setNotes('');
        } catch (error) {
            hideMessage();
            message.error(error)
        }
    }
    useEffect(() => {
        if (displayData?.caseId) {
            if (refreshTrigger === tabKey) {
                getProjectNotesById(displayData?.caseId)
            }
        }
    }, [displayData, refreshTrigger, tabKey])
    const getRefreshtheTable = () => {
        getProjectNotesById(displayData?.caseId)
    }
    return (
        <>
            <div style={{ position: 'relative', width: '100%' }}>
                <Input.TextArea
                    placeholder="Enter Internal Comments"
                    rows={2}
                    value={notes}
                    onChange={(e) => {
                        const inputValue = e.target.value;
                        const error = validateDescriptionField(inputValue, 2500);
                        if (error) {
                            message.error(error);
                            return;
                        }
                        setNotes(inputValue);
                    }}
                    style={{ paddingRight: '100px' }}
                />
                <Button
                    disabled={notes === null || notes === undefined || notes === ''}
                    className="button_colors"
                    onClick={handleAddNote}
                    style={{ position: 'absolute', right: '20px', bottom: '5px' }}
                >
                    Add
                </Button>
            </div>
            {allNotes?.length > 0 ?
                <div>
                    {allNotes &&
                        allNotes.map((note, index) => {
                            return (
                                <div
                                    key={index}
                                    className="cnote-card"
                                    style={{
                                        backgroundColor: '#F5F5F7',
                                        color: '#134B70',
                                        padding: 10,
                                        borderRadius: 5,
                                        marginTop: 10,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: 10,
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <p style={{ fontSize: 12 }}>{note.name}</p>
                                        <div style={{ fontSize: 12, gap: 10, display: "flex", alignItems: "center" }}>
                                            <p>{convertAndFormatDateTime2(note.time, companyProfile, profile)}</p> {profile.userId === note.id &&
                                                <p className="cdelete-icon"><FeatherIcon icon="trash-2" size={16} style={{ color: "red", cursor: "pointer" }} onClick={() => NoteDelete(index)} /></p>}
                                        </div>
                                    </div>
                                    <p>{note.content}</p>
                                </div>
                            );
                        })}
                </div> :
                <div style={{ padding: "10%" }}>
                    <Empty />
                </div>
            }
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Case" getCallBack={getRefreshtheTable} />}
        </>)
}
UserTable.propTypes = {
    displayData: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired
};
export default React.memo(UserTable)